/* eslint-disable react/button-has-type */

import React, { useState } from 'react';
import Logo from 'assets/images/logo-conlicitacao-dark.png';
import Bandeiras from 'assets/images/bandeiras_register.png';
import IconEscudo from 'assets/images/colored_icons/escudo_icon.svg';
import TempoIcon from 'assets/images/colored_icons/relogio_icon.svg';
import EstrategiaIcon from 'assets/images/colored_icons/estrategia_icon.svg';
import ConsultoriaIcon from 'assets/images/colored_icons/consultoria_icon.svg';
import FunilIcon from 'assets/images/colored_icons/funil_icon.svg';
import MetodologiaIcon from 'assets/images/colored_icons/icon_metodologia.svg';
import DadosIcon from 'assets/images/colored_icons/dados_icon.svg';
import SuporteIcon from 'assets/images/colored_icons/suporte_icon.svg';
import BoletimIcon from 'assets/images/colored_icons/icon-boletins.svg';
import LogoTerra from 'assets/images/colored_icons/logo_terra.svg';
import LogoSegline from 'assets/images/colored_icons/logo_segline.svg';
import IconOportunidade from 'assets/images/colored_icons/oportunidade.svg';
import IconAvaliacao from 'assets/images/colored_icons/icon_avaliacao.svg';
import IconEmpresa from 'assets/images/colored_icons/empresa.svg';
import Logos from 'assets/images/colored_icons/logos.svg';
import SetaIcon from 'assets/images/colored_icons/seta.svg';
import BgAssinante from 'assets/images/assinantes_session.png';
import ExperientRegisterModal from 'components/atoms/experient_register_modal';
import { register_checkout_access_former_subscriber } from 'services/actions/update_register_beginner';
import { openSupportChat } from 'services/support_chat';
import { Container } from './styles';
import CheckoutSaleRegister from '../checkout_sale_register';

const FormerSubscriber = () => {
  const [wasSubscriber, setWasSubscriber] = useState<boolean>(false);

  if (wasSubscriber) {
    return <CheckoutSaleRegister typeClient="was_subscribe" />;
  }

  const handleClick = async () => {
    (async () => {
      await register_checkout_access_former_subscriber();
    })();

    setWasSubscriber(true);
  };

  return (
    <Container>
      <div className="w-100 bg-img">
        <div className="container mt-5">
          <div className="row mt-5">
            <div className="col-md-12 text-center mt-5">
              <img
                className="card-img-top mt-2"
                src={Logo}
                alt="ConLicitação"
                style={{ width: '230px' }}
              />
            </div>
          </div>

          <div className="row mt-5">
            <div className="col-md-12 text-center">
              <h1>Maximize suas vendas para o governo</h1>

              <h4 className="mb-5 lh-lg">
                Economize tempo e garanta a segurança necessária <br />
                para não perder nenhuma oportunidade
              </h4>

              <iframe
                width="560"
                height="315"
                src="https://www.youtube.com/embed/WGbAVA4r6oo"
                title="YouTube video player"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
              />

              <h5 className="mt-4 font-weight-bold">
                Não perca mais oportunidades de vendas ao governo
              </h5>

              <h6>
                <strong>Oferta imperdível: </strong>Conheça nosso Plano Premium com mais de 20
                funcionalidades que te <br /> ajudam a economizar tempo e garantir segurança na
                gestão dos processos de licitação
              </h6>

              <button
                type="button"
                className="button-comprar mt-5 p-2"
                onClick={() => handleClick()}
              >
                QUERO ASSINAR O PLANO PREMIUM
              </button>

              <br />

              <img src={Bandeiras} alt="Bandeiras" className="mt-4" />

              <h1 className="mt-5">O que você vai alcançar ao contratar este plano</h1>
            </div>
          </div>

          <div className="row mb-5">
            <div className="col-md-12">
              <div className="card-deck mt-3">
                <div className="card">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-1">
                        <img src={TempoIcon} alt="Tempo" width={37} />
                      </div>

                      <div className="col-md-11">
                        <h5 className="card-title m-2">Economia de tempo</h5>
                      </div>
                    </div>

                    <p className="card-text mt-3">
                      Com mais de 20 funcionalidades disponíveis, nossa plataforma permite que você
                      encontre licitações e gerencie processos de vendas de forma mais eficiente,
                      economizando horas de trabalho manual. Você terá mais tempo para se concentrar
                      em outras tarefas importantes.
                    </p>
                  </div>
                </div>

                <div className="card">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-1">
                        <img src={IconEscudo} alt="Segurança" width={37} />
                      </div>

                      <div className="col-md-11">
                        <h5 className="card-title m-2">Garantia de segurança</h5>
                      </div>
                    </div>

                    <p className="card-text mt-3">
                      Nossas funcionalidades ajudam a minimizar os riscos para que não perca
                      licitações de interesse, não erre na documentação e na gestão dos processos.
                      Isso significa mais confiança e tranquilidade no dia a dia.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-12">
              <div className="card-deck mt-3">
                <div className="card">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-1">
                        <img src={EstrategiaIcon} alt="estratégia" width={37} />
                      </div>

                      <div className="col-md-11">
                        <h5 className="card-title m-2">Acesso a informações estratégicas</h5>
                      </div>
                    </div>

                    <p className="card-text mt-3">
                      Com as ferramentas estratégicas disponíveis no Plano Premium, terá acesso a
                      informações do mercado e dos concorrentes, permitindo tomar decisões mais
                      assertivas e estratégicas nas vendas ao governo.
                    </p>
                  </div>
                </div>

                <div className="card">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-1">
                        <img src={ConsultoriaIcon} alt="Consultoria" width={37} />
                      </div>

                      <div className="col-md-11">
                        <h5 className="card-title m-2">Consultorias de apoio</h5>
                      </div>
                    </div>

                    <p className="card-text mt-3">
                      O Plano Premium oferece consultorias técnicas e jurídicas permitindo
                      direcionamento correto em suas vendas ao governo, suporte especializado para
                      superar eventuais desafios e garantir o sucesso nas licitações.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <hr />

        <div className="container">
          <div className="row mt-5">
            <div className="col-md-12">
              <h1>Por que escolher o ConLicitação</h1>

              <div className="row px-5 mb-3 mt-3">
                <div className="col-md-1">
                  <img src={FunilIcon} alt="Consultoria" width={106} />
                </div>

                <div className="col-md-11">
                  <p className="ml-5 mt-4">
                    A plataforma ConLicitação foi desenvolvida para entregar as oportunidades certas
                    <br />
                    para cada cliente, filtrando as licitações de acordo com o perfil de negócio.
                  </p>
                </div>
              </div>

              <div className="row px-5 mb-3">
                <div className="col-md-1">
                  <img src={MetodologiaIcon} alt="Consultoria" width={106} />
                </div>

                <div className="col-md-11">
                  <p className="ml-5 mt-4">
                    Nossa metodologia de sucesso é fruto de 23 anos de experiência no mercado, com
                    <br />
                    investimentos altíssimos em ferramentas tecnológicas e capacitações constantes
                    <br />
                    dos nossos especialistas.
                  </p>
                </div>
              </div>

              <div className="row px-5 mb-3">
                <div className="col-md-1">
                  <img src={DadosIcon} alt="Consultoria" width={106} />
                </div>

                <div className="col-md-11">
                  <p className="ml-5 mt-4">
                    Ao contratar o ConLicitação, sua empresa terá acesso à base de dados mais
                    <br />
                    atualizada do mercado, gerenciará todas as etapas do processo licitatório em um
                    <br />
                    só lugar, reduzindo custos, tempo e maximizando suas vendas.
                  </p>
                </div>
              </div>

              <div className="row px-5 mb-3">
                <div className="col-md-1">
                  <img src={SuporteIcon} alt="Consultoria" width={106} />
                </div>

                <div className="col-md-11">
                  <p className="ml-5 mt-4">
                    Terá suporte especializado para garantir o sucesso nas vendas ao Governo. Se sua
                    <br />
                    empresa busca excelência em processos licitatórios, contratar o ConLicitação é a
                    <br />
                    escolha certa.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <hr className="mb-0" />

        <div className="container-fluid bg-premium">
          <div className="row">
            <div className="col-md-6" />

            <div className="col-md-5 mt-5" style={{ fontSize: '18px' }}>
              <h3>Para quem é o Plano Premium</h3>

              <p className="mt-5">
                Nosso plano Premium foi desenvolvido para atender às necessidades de empresas que
                buscam maximizar suas vendas para o governo e desejam ter acesso às funcionalidades
                mais completas e avançadas da plataforma ConLicitação.
              </p>

              <p>
                Feito para empresas que buscam economizar tempo, garantir segurança em seus
                processos, localizar as licitações certas, gerir documentos e processos, ter
                informações do mercado e dos concorrentes e ainda contar com consultorias
                especializadas para tomar decisões certas.
              </p>

              <p>
                Não importa se é uma pequena, média ou grande empresa, o plano Premium é a escolha
                certa para impulsionar as vendas para o governo e aumentar os resultados.
              </p>

              <button
                type="button"
                className="button-comprar mt-3 p-2"
                onClick={() => handleClick()}
              >
                clique aqui para contratar agora
              </button>
            </div>
          </div>
        </div>

        <div className="container mt-5 mb-5">
          <div className="row mb-5">
            <div className="col-md-12 text-center mt-5">
              <h1>
                Ao contratar esse plano, você terá acesso a mais
                <br /> de 20 funcionalidades, veja as principais
              </h1>

              <div className="row mt-5">
                <div className="col-md-6">
                  <div id="accordion">
                    <div className="card">
                      <div className="card-header" id="headingOne">
                        <div className="row">
                          <div className="col-2">
                            <img src={BoletimIcon} alt="Consultoria" width={32} />
                          </div>

                          <div className="col-8">
                            <h5 className="mb-0">
                              <button
                                className="btn btn-link font-weight-bold"
                                data-toggle="collapse"
                                data-target="#boletim"
                                aria-expanded="true"
                                aria-controls="boletim"
                              >
                                Boletins e Encontrar Licitações
                              </button>
                            </h5>
                          </div>

                          <div className="col-2">
                            <button
                              className="btn btn-link font-weight-bold"
                              data-toggle="collapse"
                              data-target="#boletim"
                              aria-expanded="true"
                              aria-controls="boletim"
                            >
                              <img src={SetaIcon} alt="Consultoria" width={32} />
                            </button>
                          </div>
                        </div>
                      </div>

                      <div
                        id="boletim"
                        className="collapse"
                        aria-labelledby="headingOne"
                        data-parent="#accordion"
                      >
                        <div className="text-left p-3">
                          <p>
                            Encontre as licitações certas para o seu negócio, extraídas de mais de 6
                            mil fontes oficiais, reunidas em um único lugar.
                          </p>

                          <p>
                            Você economiza tempo, evita análises desnecessárias e aumenta suas
                            chances de vencer as licitações, tornando-se mais competitivo e ainda
                            pode se dedicar a outras atividades importantes da sua empresa sem se
                            preocupar em perder as melhores oportunidades.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-md-6">
                  <div id="accordion">
                    <div className="card">
                      <div className="card-header" id="headingOne">
                        <div className="row">
                          <div className="col-2">
                            <img src={BoletimIcon} alt="Consultoria" width={32} />
                          </div>

                          <div className="col-8">
                            <h5 className="mb-0">
                              <button
                                className="btn btn-link font-weight-bold"
                                data-toggle="collapse"
                                data-target="#monitoramento"
                                aria-expanded="true"
                                aria-controls="monitoramento"
                              >
                                Monitoramento de Chat
                              </button>
                            </h5>
                          </div>

                          <div className="col-2">
                            <button
                              className="btn btn-link font-weight-bold"
                              data-toggle="collapse"
                              data-target="#monitoramento"
                              aria-expanded="true"
                              aria-controls="monitoramento"
                            >
                              <img src={SetaIcon} alt="Consultoria" width={32} />
                            </button>
                          </div>
                        </div>
                      </div>

                      <div
                        id="monitoramento"
                        className="collapse"
                        aria-labelledby="headingOne"
                        data-parent="#accordion"
                      >
                        <div className="text-left p-3">
                          <p>
                            Monitore todas as mensagens das sessões públicas de pregão que você
                            participou e seja avisado sobre as movimentações em tempo real.
                          </p>

                          <p>
                            Atenda às solicitações do pregoeiro de forma ágil e eficiente, sem
                            perder nenhuma oportunidade de venda.
                          </p>

                          <p>
                            Tenha mais qualidade de vida ao monitorar uma licitação, sem consultas
                            frequentes aos chats das licitações que participou.
                          </p>

                          <p>
                            Com o Monitoramento de Chat, você otimiza sua performance e
                            produtividade, garantindo o sucesso nas oportunidades que participou
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="row mt-4">
                <div className="col-md-6">
                  <div id="accordion">
                    <div className="card">
                      <div className="card-header" id="headingOne">
                        <div className="row">
                          <div className="col-2">
                            <img src={BoletimIcon} alt="Consultoria" width={32} />
                          </div>

                          <div className="col-8">
                            <h5 className="mb-0">
                              <button
                                className="btn btn-link font-weight-bold"
                                data-toggle="collapse"
                                data-target="#gerenciar"
                                aria-expanded="true"
                                aria-controls="gerenciar"
                              >
                                Gerenciar Documentos
                              </button>
                            </h5>
                          </div>

                          <div className="col-2">
                            <button
                              className="btn btn-link font-weight-bold"
                              data-toggle="collapse"
                              data-target="#gerenciar"
                              aria-expanded="true"
                              aria-controls="gerenciar"
                            >
                              <img src={SetaIcon} alt="Consultoria" width={32} />
                            </button>
                          </div>
                        </div>
                      </div>

                      <div
                        id="gerenciar"
                        className="collapse"
                        aria-labelledby="headingOne"
                        data-parent="#accordion"
                      >
                        <div className="text-left p-3">
                          <p>Atualize automaticamente os Documentos de Habilitação.</p>

                          <p>
                            Inclua seus próprios documentos para uma melhor organização e controle
                            de prazos.
                          </p>

                          <p>
                            Compartilhe documentos facilmente e agilize a montagem das pastas de
                            habilitação com apenas alguns cliques.
                          </p>

                          <p>
                            Economize tempo, tenha segurança em sua documentação, tornando a
                            habilitação muito mais fácil, eficiente e um diferencial perante os
                            adversários.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-md-6">
                  <div id="accordion">
                    <div className="card">
                      <div className="card-header" id="headingOne">
                        <div className="row">
                          <div className="col-2">
                            <img src={BoletimIcon} alt="Consultoria" width={32} />
                          </div>

                          <div className="col-8">
                            <h5 className="mb-0">
                              <button
                                className="btn btn-link font-weight-bold"
                                data-toggle="collapse"
                                data-target="#juridico"
                                aria-expanded="true"
                                aria-controls="juridico"
                              >
                                Jurídico Fácil
                              </button>
                            </h5>
                          </div>

                          <div className="col-2">
                            <button
                              className="btn btn-link font-weight-bold"
                              data-toggle="collapse"
                              data-target="#juridico"
                              aria-expanded="true"
                              aria-controls="juridico"
                            >
                              <img src={SetaIcon} alt="Consultoria" width={32} />
                            </button>
                          </div>
                        </div>
                      </div>

                      <div
                        id="juridico"
                        className="collapse"
                        aria-labelledby="headingOne"
                        data-parent="#accordion"
                      >
                        <div className="text-left p-3">
                          <p>
                            Acesso ilimitado a legislação, jurisprudências e orientações de uma
                            equipe especializada em direito administrativo, com ampla experiência em
                            vendas ao governo.
                          </p>

                          <p>
                            Minimize os riscos jurídicos e tome decisões estratégicas eficientes,
                            aumentando chance de sucesso nas vendas ao governo
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="row mt-4">
                <div className="col-md-6">
                  <div id="accordion">
                    <div className="card">
                      <div className="card-header" id="headingOne">
                        <div className="row">
                          <div className="col-2">
                            <img src={BoletimIcon} alt="Consultoria" width={32} />
                          </div>

                          <div className="col-8">
                            <h5 className="mb-0">
                              <button
                                className="btn btn-link font-weight-bold"
                                data-toggle="collapse"
                                data-target="#gerenciar-licitacao"
                                aria-expanded="true"
                                aria-controls="gerenciar-licitacao"
                              >
                                Gerenciar Licitações
                              </button>
                            </h5>
                          </div>

                          <div className="col-2">
                            <button
                              className="btn btn-link font-weight-bold"
                              data-toggle="collapse"
                              data-target="#gerenciar-licitacao"
                              aria-expanded="true"
                              aria-controls="gerenciar-licitacao"
                            >
                              <img src={SetaIcon} alt="Consultoria" width={32} />
                            </button>
                          </div>
                        </div>
                      </div>

                      <div
                        id="gerenciar-licitacao"
                        className="collapse"
                        aria-labelledby="headingOne"
                        data-parent="#accordion"
                      >
                        <div className="text-left p-3">
                          <p>
                            Gerencie todas as licitações em um só lugar! controle e gestão de todas
                            as vendas, compreendendo em que etapa cada licitação se encontra, quem
                            são os responsáveis, quais tarefas já foram executadas e quais ainda
                            precisam ser feitas.
                          </p>

                          <p>
                            Com integração nos principais portais de compras essa ferramenta oferece
                            previsibilidade de vendas e gestão dos envolvidos
                          </p>

                          <p>
                            Evita erros e perda de prazos. Com a rica base histórica de performance,
                            você pode ter uma visão completa do quanto já vendeu, quanto deixou de
                            vender e os motivos de sucesso ou perda da venda.{' '}
                          </p>

                          <p>Você terá segurança e eficiência na gestão do seu negócio.</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-md-6">
                  <div id="accordion">
                    <div className="card">
                      <div className="card-header" id="headingOne">
                        <div className="row">
                          <div className="col-2">
                            <img src={BoletimIcon} alt="Consultoria" width={32} />
                          </div>

                          <div className="col-8">
                            <h5 className="mb-0">
                              <button
                                className="btn btn-link font-weight-bold"
                                data-toggle="collapse"
                                data-target="#concorrente"
                                aria-expanded="true"
                                aria-controls="concorrente"
                              >
                                Análise de Concorrentes
                              </button>
                            </h5>
                          </div>

                          <div className="col-2">
                            <button
                              className="btn btn-link font-weight-bold"
                              data-toggle="collapse"
                              data-target="#concorrente"
                              aria-expanded="true"
                              aria-controls="concorrente"
                            >
                              <img src={SetaIcon} alt="Consultoria" width={32} />
                            </button>
                          </div>
                        </div>
                      </div>

                      <div
                        id="concorrente"
                        className="collapse"
                        aria-labelledby="headingOne"
                        data-parent="#accordion"
                      >
                        <div className="text-left p-3">
                          <p>
                            Ferramenta estratégica que fornece informações valiosas sobre os
                            concorrentes, incluindo dados cadastrais da empresa e dos sócios,
                            histórico de participação em licitações e preços praticados
                          </p>

                          <p>
                            Identifique possíveis pontos fracos ou vulnerabilidades em seus
                            concorrentes, permitindo que os clientes sejam mais eficazes na
                            elaboração de suas propostas e na preparação para as licitações.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="row mt-4">
                <div className="col-md-6">
                  <div id="accordion">
                    <div className="card">
                      <div className="card-header" id="headingOne">
                        <div className="row">
                          <div className="col-2">
                            <img src={BoletimIcon} alt="Consultoria" width={32} />
                          </div>

                          <div className="col-8">
                            <h5 className="mb-0">
                              <button
                                className="btn btn-link font-weight-bold"
                                data-toggle="collapse"
                                data-target="#mercado"
                                aria-expanded="true"
                                aria-controls="mercado"
                              >
                                Análise de Mercado
                              </button>
                            </h5>
                          </div>

                          <div className="col-2">
                            <button
                              className="btn btn-link font-weight-bold"
                              data-toggle="collapse"
                              data-target="#mercado"
                              aria-expanded="true"
                              aria-controls="mercado"
                            >
                              <img src={SetaIcon} alt="Consultoria" width={32} />
                            </button>
                          </div>
                        </div>
                      </div>

                      <div
                        id="mercado"
                        className="collapse"
                        aria-labelledby="headingOne"
                        data-parent="#accordion"
                      >
                        <div className="text-left p-3">
                          <p>
                            Obtenha informações valiosas sobre o mercado, como a quantidade de
                            licitações que ocorrem em seu perfil, ranking dos órgãos públicos que
                            mais compram, regiões que mais compram, preços praticados e principais
                            concorrentes.
                          </p>

                          <p>
                            Com essas informações em mãos é possível tomar decisões mais assertivas
                            sobre suas próprias participações em licitações, economizando tempo e
                            melhorando sua performance nas vendas ao governo.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-md-6" />
              </div>
            </div>
          </div>

          <div className="row mt-5">
            <div className="col-md-12 text-center">
              <h3 className="mt-5 text-center">
                Aproveite agora as melhores oportunidades de vendas
                <br /> ao governo e comece a expandir seus negócios
              </h3>

              <button
                type="button"
                className="mt-4 button-comprar p-2"
                onClick={() => handleClick()}
              >
                CLIQUE AQUI PARA CONTRATAR NOSSO PLANO EXCLUSIVO
              </button>
            </div>
          </div>
        </div>

        <hr className="mt-5" />

        <div className="container mt-5">
          <div className="row">
            <div className="col-md-12">
              <h1>
                Veja o que dizem <br />
                nossos clientes
              </h1>
            </div>

            <div className="card-deck m-5">
              <div className="card">
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-3">
                      <img src={LogoSegline} alt="Depoimento" width={90} />
                    </div>

                    <div className="col-md-9">
                      <h5 className="card-title">Bruna Ladewig</h5>

                      <p>Segline Distribuidora e Importadora de Equipamentos de Seguranca LTDA</p>

                      <p className="card-text">
                        Já são alguns anos trabalhando com o ConLicitação, inclusive, a empresa não
                        estaria hoje competitiva no mercado se não fosse por vocês! Renovamos todo o
                        ano à assinatura com a certeza de receber Boletins de qualidade, filtrados e
                        adequados ao nosso ramo! Além de disponibilizar lives com conteúdos
                        relevantes e análise de mercado! Estamos atuando desde 2003 e hoje,
                        trabalhamos somente com vendas por meio de processos licitatórios. Essa
                        parceria é reconhecida, além de diversas ferramentas disponíveis no painel
                        de assinante, o ConLicitação oferece acesso ao “Bolsa de Empregos”, muito
                        útil para busca de currículos ou vagas! Por isso, deixamos aqui, nosso
                        obrigado!
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="card">
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-3">
                      <img src={LogoTerra} alt="Depoimento" width={90} />
                    </div>

                    <div className="col-md-9">
                      <h5 className="card-title">Terra Perfurações Ltda.</h5>

                      <p className="card-text">
                        O Portal do Grupo ConLicitação é bastante completo, mas ressalta-se o
                        monitoramento e acompanhamento de licitações. As lives informativas são
                        sensacionais e os esclarecimentos são primordiais. Os vídeos com conteúdos
                        informativos e legislatórios são espetaculares. Um diferencial. Em suma: se
                        você quiser obter sucesso e extrair o máximo das licitações, é indispensável
                        assinar o Portal. Parabéns a todos!
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="container-fluid resultados">
          <div className="row p-5">
            <div className="col-md-12 text-center">
              <h3>
                Potencialize seus resultados <br /> como nossos clientes já fizeram
              </h3>

              <div className="row p-5">
                <div className="col-md-3" />

                <div className="col-md-2">
                  <img src={IconEmpresa} alt="Empresa" width={80} />

                  <h3 className="mt-2">+20 MIL</h3>

                  <p>
                    empresas
                    <br />
                    assinantes
                  </p>
                </div>

                <div className="col-md-2">
                  <img src={IconAvaliacao} alt="Avaliação" width={80} />

                  <h3 className="mt-2">+80 MIL</h3>

                  <p>
                    usuários
                    <br />
                    ativos
                  </p>
                </div>

                <div className="col-md-2">
                  <img src={IconOportunidade} alt="Depoimento" width={80} />

                  <h3 className="mt-2">+900 MIL</h3>

                  <p>
                    oportunidades de
                    <br />
                    vendas em 2022
                  </p>
                </div>

                <div className="col-md-3" />
              </div>

              <img src={Logos} alt="Logos empresas" />
            </div>
          </div>
        </div>

        <div className="container-fluid">
          <div className="row">
            <div className="col-md-6 text-center">
              <img src={BgAssinante} alt="Depoimento" width={561} />
            </div>

            <div className="col-md-5 mt-5" style={{ fontSize: '18px' }}>
              <h3>
                Quero fazer parte das 20 mil empresas assinantes e <br />
                acessar mais de 900 mil oportunidades de vendas
              </h3>

              <p className="mt-4">
                Se você deseja ter acesso completo a todas as funcionalidades do nosso serviço, o
                plano Premium é a escolha certa para você. Com ele, você poderá desfrutar de todas
                as ferramentas estratégicas que ajudarão a aumentar suas chances de sucesso nas
                vendas ao governo.
              </p>

              <p>
                Além disso, com o plano Premium, você terá acesso a suporte exclusivo e
                personalizado para ajudá-lo em todas as etapas do processo de licitação.
              </p>

              <p>
                Não perca mais tempo e aproveite agora mesmo essa oportunidade única de melhorar sua
                performance nas vendas ao governo com nosso plano Premium. Clique no botão abaixo e
                comece já!
              </p>

              <button
                type="button"
                className="button-comprar mt-3 p-2 btn-lg mb-5"
                onClick={() => handleClick()}
              >
                CLIQUE AQUI PARA CONTRATAR AGORA
              </button>
            </div>
          </div>
        </div>

        <hr className="mt-0" />

        <div className="container mt-5">
          <div className="col-md-12">
            <h2 className="text-center font-weight-bold mb-5">
              Economize tempo e otimize a performance do seu negócio nas licitações públicas,
              garantindo um faturamento ainda maior. Contrate agora!
            </h2>

            <div className="row mt-5">
              <div className="col-md-12">
                <div className="container">
                  <div className="row mt-4">
                    <div className="col-md-1"> </div>

                    <div className="col-md-5 acesso">
                      <h3 className="mb-3">
                        <span className="badge badge-secondary">ASSINATURA</span>
                      </h3>

                      <p className="font-weight-bold h1">Plano Premium</p>

                      <p>12 meses de acesso</p>

                      <ul>
                        <li>- Boletins diários</li>

                        <li>- Encontrar licitações</li>

                        <li>- Encontrar acompanhamentos</li>

                        <li>- Análise de mercado</li>

                        <li>- Suporte Jurídico</li>

                        <li>- Gerenciar licitações</li>

                        <li>- Gerenciar Documentos</li>

                        <li>- Análise de concorrentes</li>

                        <li>- Monitorar chat</li>

                        <li>- ConLicita Go</li>
                      </ul>
                    </div>

                    <div className="col-md-6">
                      <div className="card mb-4" style={{ width: '22rem' }}>
                        <div className="card-header font-weight-bold">
                          <h5 className="font-weight-bold mb-0">ASSINATURA</h5>

                          <div className="row">
                            <div className="col-md-9">
                              <p className="acesso">12 meses de acesso</p>
                            </div>

                            <div className="col-md-3">
                              <h4>
                                <span className="badge badge-success">- 10%</span>
                              </h4>
                            </div>
                          </div>
                        </div>

                        <div className="card-body">
                          <p className="mercado-subtitle mb-0">De</p>

                          <p className="valor mt-0">
                            <s>R$ 3.185,80</s>
                          </p>

                          <p className="mercado-subtitle mb-0">por</p>

                          <p className="valor mb-0">
                            5x de
                            <strong> R$ 573.44 </strong>
                          </p>

                          <h6 className="mt-2 mb-4">sem juros no cartão.</h6>

                          <button type="button" className="button" onClick={() => handleClick()}>
                            ASSINAR PLANO PREMIUM
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="text-center">
              <span>
                * Este plano corresponde a uma assinatura padrão: Até 4 segmentos distintos conforme
                objeto social do CNPJ cadastrado.
              </span>
            </div>
          </div>
        </div>

        <hr />

        <div className="container mt-5 mb-5">
          <div className="row">
            <div className="col-md-12">
              <h5>Quer habilitar seu periodo de teste?</h5>

              <h1>Fale com nossa equipe</h1>

              <button
                type="button"
                className="button"
                onClick={() => {
                  openSupportChat();
                }}
              >
                Entrar em contato
              </button>
            </div>
          </div>
        </div>

        <hr />

        <div className="container">
          <div className="row mt-5 mb-5">
            <div className="col-md-12">
              <p className="mercado-licitacao text-center">Perguntas Frequentes</p>

              <div id="accordion p-4">
                <div className="card">
                  <div className="card-header" id="headingOne">
                    <h5 className="mb-0">
                      <button
                        className="btn btn-link font-weight-bold"
                        data-toggle="collapse"
                        data-target="#collapseOne"
                        aria-expanded="true"
                        aria-controls="collapseOne"
                      >
                        Como o ConLicitação vai me ajudar a vender mais?
                      </button>
                    </h5>
                  </div>

                  <div
                    id="collapseOne"
                    className="collapse"
                    aria-labelledby="headingOne"
                    data-parent="#accordion"
                  >
                    <div className="card-body">
                      Nós forneceremos a você as inúmeras oportunidades de vendas que o governo
                      divulga e te ensinaremos como aproveitá-las para vender para o governo.
                    </div>
                  </div>
                </div>

                <div className="card">
                  <div className="card-header" id="headingTwo">
                    <h5 className="mb-0">
                      <button
                        className="btn btn-link collapsed font-weight-bold"
                        data-toggle="collapse"
                        data-target="#collapseTwo"
                        aria-expanded="false"
                        aria-controls="collapseTwo"
                      >
                        Como funcionam de oportunidades segmentadas?
                      </button>
                    </h5>
                  </div>

                  <div
                    id="collapseTwo"
                    className="collapse"
                    aria-labelledby="headingTwo"
                    data-parent="#accordion"
                  >
                    <div className="card-body">
                      Nós selecionamos as oportunidades de vendas diariamente de acordo com o
                      segmento e área de atuação da sua empresa, para economizar o seu tempo e
                      permitir que você se concentre nas vendas.
                    </div>
                  </div>
                </div>

                <div className="card">
                  <div className="card-header" id="headingThree">
                    <h5 className="mb-0">
                      <button
                        className="btn btn-link collapsed font-weight-bold"
                        data-toggle="collapse"
                        data-target="#collapseThree"
                        aria-expanded="false"
                        aria-controls="collapseThree"
                      >
                        É garantido que vou vender ao governo?
                      </button>
                    </h5>
                  </div>

                  <div
                    id="collapseThree"
                    className="collapse"
                    aria-labelledby="headingThree"
                    data-parent="#accordion"
                  >
                    <div className="card-body">
                      Não podemos garantir que você venderá ao governo, mas garantimos que você terá
                      acesso às melhores oportunidades de vendas, conhecimento de como aproveitá-las
                      e auxílio dos nossos especialistas em qualquer etapa da venda.
                    </div>
                  </div>
                </div>

                <div className="card mb-5">
                  <div className="card-header" id="headingThree">
                    <h5 className="mb-0">
                      <button
                        className="btn btn-link collapsed font-weight-bold"
                        data-toggle="collapse"
                        data-target="#collapseThree"
                        aria-expanded="false"
                        aria-controls="collapseThree"
                      >
                        Qual é a vantagem desse Plano Especial em relação aos outros oferecidos pelo
                        ConLicitação?
                      </button>
                    </h5>
                  </div>

                  <div
                    id="collapseThree"
                    className="collapse"
                    aria-labelledby="headingThree"
                    data-parent="#accordion"
                  >
                    <div className="card-body">
                      Esse plano combina a eficiência da nossa plataforma no pacote de serviços
                      básicos com um treinamento exclusivo para que você possa aproveitar ao máximo
                      as oportunidades do mercado público. Além disso, oferecemos suporte completo e
                      especializado durante toda a sua jornada, o que o ajudará a superar qualquer
                      dificuldade e aumentar suas chances de vender para o governo. Ele é
                      especialmente desenvolvido para aqueles que não têm experiência ou se sentem
                      inseguros em fechar contratos com o governo.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <ExperientRegisterModal />
      </div>
    </Container>
  );
};

export default FormerSubscriber;
